import { Accordion as qo, AccordionItem as Ko } from "./accordion.js";
import { A as Yo } from "./accordionPanel-89132988.js";
import { AspectRatio as $o } from "./aspectRatio.js";
import { AvatarNew as rt } from "./avatar.js";
import { Badge as tt } from "./badge.js";
import { BlogVideo as pt } from "./blogVideo.js";
import { Breadcrumb as mt } from "./breadcrumb.js";
import { BulkActionBar as nt } from "./bulkActionBar.js";
import { Button as xt } from "./button.js";
import { ButtonGroup as lt } from "./buttonGroup.js";
import { Card as ct } from "./card.js";
import { CardIllustration as Tt } from "./cardIllustration.js";
import { CardIllustrationSection as Ct } from "./cardIllustrationSection.js";
import { C as gt, b as yt, a as bt, D as kt, _ as Mt, M as Lt, c as ht, R as Dt, d as It, e as At, f as Bt, T as vt } from "./index-f5b44da3.js";
import { Chip as Gt, ChipGroup as Ht } from "./chip.js";
import { CreditCardInput as Et } from "./creditCardInput.js";
import { CTAButton as Vt } from "./ctaButton.js";
import { CurrencyInput as Nt } from "./currencyInput.js";
import { DataList as _t } from "./dataList.js";
import { DataTable as Jt } from "./dataTable.js";
import { DatePicker as Xt } from "./datePicker.js";
import { Disclosures as Kt } from "./disclosure.js";
import { Divider as Yt, DividerLayout as Zt, DividerThickness as $t } from "./divider.js";
import { Drawer as re, DrawerContent as oe, DrawerFooter as te, DrawerHeader as ee } from "./drawer.js";
import { FeatureText as ie } from "./featureText.js";
import { FileProgress as ae, FileUpload as ne, FileUploadProvider as fe, UPLOAD_STATUS as xe, useFileUploadContext as se } from "./fileupload.js";
import { Filter as ue, FilterGroup as ce, FiltersContainer as de, StyledChipGroupContainer as Te, StyledFilterContainer as Se, StyledFilterGroup as Ce, StyledTableFilterGroup as Pe } from "./filter.js";
import { FocusTrap as ye, FocusTrapNavigationType as be } from "./focusTrap.js";
import { GlobalAttributeBar as Me } from "./globalAttributeBar.js";
import { Grid as he } from "./grid.js";
import { Hero as Ie, HeroContentAlignment as Ae } from "./hero.js";
import { a as ve, b as Fe, I as Ge } from "./index-5d0f31c6.js";
import { IconButton as we } from "./iconButton.js";
import { Image as Re } from "./image.js";
import { DecrementStepper as Ue, IncrementSelector as Ne, IncrementStepper as Oe, NumberInputField as _e } from "./incrementSelector.js";
import { InLineAlert as Je } from "./inLineAlert.js";
import { InLineText as Xe } from "./inLineText.js";
import { Carousel as Ke } from "./carousel.js";
import { CloseButton as Ye } from "./closeButton.js";
import { HelperText as $e, InputState as je } from "./helperText.js";
import { Label as op } from "./label.js";
import { SecondaryNav as ep } from "./secondaryNav.js";
import { JumpLink as ip } from "./jumplink.js";
import { LandingHero as ap } from "./landingHero.js";
import { LandingPageVideo as fp } from "./landingPageVideo.js";
import { Link as sp } from "./link.js";
import { List as up, ListIcon as cp, ListItem as dp } from "./list.js";
import { M as Sp } from "./mapMarker-3af5c1ff.js";
import { MarkerVariants as Pp } from "./mapMarker.js";
import { MarketingComparisonTable as yp, MarketingComparisonTableColumnButton as bp } from "./marketingComparisonTable.js";
import { MarketingDataList as Mp } from "./marketingDataList.js";
import { MarketingList as hp } from "./marketingList.js";
import { MediaDisclosureButton as Ip } from "./mediaDisclosureButton.js";
import { MegaMenu as Bp } from "./megaMenu.js";
import { E as Fp, a as Gp } from "./index-f2264f1e.js";
import { ModalVideo as wp } from "./modalVideo.js";
import { ModalBody as Rp, ModalFooter as Vp, ModalHeader as Up, ModalWindow as Np } from "./modalWindow.js";
import { PageHeader as _p } from "./pageHeader.js";
import { Pagination as Jp } from "./pagination.js";
import { PhoneInput as Xp } from "./phoneInput.js";
import { PhotoGallery as Kp } from "./photoGallery.js";
import { PhotoGalleryThumbnail as Yp } from "./photoGalleryThumbnail.js";
import { PhotoGalleryLightbox as $p } from "./photosGalleryLightbox.js";
import { a as ri, P as oi, g as ti } from "./popupTip-06ee114c.js";
import { PopupTipLinks as pi } from "./popupTip.js";
import { ProgressBar as mi } from "./progressBar.js";
import { ProgressStepState as ni, ProgressTracker as fi, ProgressTrackerOrientation as xi, ProgressTrackerType as si } from "./progressTracker.js";
import { ProgressTrackerVertical as ui } from "./progressTrackerVertical.js";
import { RaisedSurface as di } from "./raisedSurface.js";
import { ReadOnlySection as Si } from "./readOnlySection.js";
import { Search as Pi } from "./search.js";
import { SearchInputLocation as yi } from "./searchInputLocation.js";
import { SegmentControl as ki } from "./segmentControl.js";
import { MultiSelectInput as Li } from "./selectInput.js";
import { S as Di } from "./singleSelectInput-6bdc2a66.js";
import { SelectionCard as Ai, SelectionTileCompactGroup as Bi } from "./selectionCard.js";
import { ShareLinks as Fi } from "./shareLinks.js";
import { ShowMoreLess as Hi } from "./showMoreLess.js";
import { SidePanel as Ei } from "./sidePanel.js";
import { Skeleton as Vi } from "./skeleton.js";
import { Slider as Ni } from "./slider.js";
import { Slot as _i } from "./slot.js";
import { SnackbarProvider as Ji, useSnackbars as Wi } from "./snackbar.js";
import { Spinner as qi } from "./spinner.js";
import { Switch as Qi } from "./switch.js";
import { TableContext as Zi, TableProvider as $i } from "./provider.js";
import { TabPanel as rm, TabPanels as om } from "./tabPanels.js";
import { Tabs as em } from "./tabs.js";
import { Tab as im, TabList as mm } from "./tabsList.js";
import { A as nm, Caption as fm, Display1 as xm, Display2 as sm, Display3 as lm, DisplayTypoGraphy as um, H1 as cm, H2 as dm, H3 as Tm, H4 as Sm, H5 as Cm, H6 as Pm, HeadingTypoGraphy as gm, Li as ym, Ol as bm, P as km, SubTitle as Mm, Text as Lm, Title as hm, Typography as Dm, Ul as Im } from "./text.js";
import { TextArea as Bm } from "./textArea.js";
import { TextDisclosure as Fm } from "./textDisclosure.js";
import { TimePickerInput as Hm } from "./timePickerInput.js";
import { Tooltip as Em } from "./tooltip.js";
import { TopBanner as Vm } from "./topBanner.js";
import { useAccessibilityProps as Nm } from "./accessibility.js";
import "./es.date.to-json-b76d522e.js";
import "./es.object.to-string-f55666a8.js";
import "./es.promise.resolve-c679daba.js";
import "./web.set-timeout-72b6430f.js";
import { d as _m } from "./debounce-350c74b3.js";
import { useEffect as n } from "react";
import { VideoPlayer as Jm } from "./videoPlayer.js";
import "./es.object.assign-7e79fd7b.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./index-8b07dec9.js";
import "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./es.array.concat-d1c9b847.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./array-method-is-strict-e5a3c878.js";
import "./getMetrics-953aa4f8.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./aria.js";
import "./cloneSlots-622cf8c9.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "react/jsx-runtime";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./es.array.join-c1bca812.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "@ucl/shared-icons";
import "./useWindowSize.js";
import "./es.array.find-index-cbf7640b.js";
import "./useMediaQuery.js";
import "./es.string.link-fd2676c6.js";
import "./actions.js";
import "./es.function.name-b230e7d4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./useSize.js";
import "./useContainmentCheck.js";
import "./slots.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./combineRefs-c9ad2c39.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./hTag.js";
import "./childrenCountCheck-bbe924c6.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./uniqueId.js";
import "./screenReaderOnly.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./es.string.match-5eb65eed.js";
import "./tableSearchView-f1b86ba0.js";
import "./es.array.splice-801adf1d.js";
import "./array-sort-7c90b530.js";
import "./tableAccordionItem-b42a40b9.js";
import "./tableV1-80a39fe6.js";
import "./currency.js";
import "./es.number.constructor-fc5c8929.js";
import "./is-pure-c0f11fe0.js";
import "./this-number-value-32e86ff7.js";
import "@ucl/shared-component-foundations/foundations";
import "./tableContainer-531abf1b.js";
import "./index-7e2f9db6.js";
import "./localeLanguages-75ceae62.js";
import "./es.array.index-of-084b82ab.js";
import "./CalendarPickerInput-55c0d122.js";
import "./index-ebdb31f7.js";
import "./usePopoverIndex.js";
import "./es.number.to-fixed-2c921bf4.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-component-foundations/themeProvider";
import "@ucl/shared-component-foundations/themes";
import "./index-8b032e93.js";
import "./index-0ec2583e.js";
import "./index-fa01101f.js";
import "./___vite-browser-external_commonjs-proxy-5e28079b.js";
import "./hooks_internal.js";
import "./analytics.js";
import "./es.array.unscopables.flat-map-40df3ae6.js";
import "./es.array.reduce-2985ed2c.js";
import "./environment-is-node-a035d787.js";
import "./environment-ddee5959.js";
import "./useIsFirstRender.js";
import "./usePagination.js";
import "./useInterval.js";
import "./useSwipe-7297d580.js";
import "./shareIcons.js";
import "./validate-arguments-length-eb516e5b.js";
import "./safe-get-built-in-a8d8c20c.js";
import "./showMoreLess.styles-679d33f9.js";
import "./useTimeout.js";
import "./tabs.provider-ae82732d.js";
function zo(p, o) {
  return o.fn(function() {
    return {
      open: o.fn(),
      send: function() {
        var r = this;
        return new Promise(function(t) {
          setTimeout(function() {
            r.readyState = 4, r.status = p, r.responseText = '{"data": "success"}', t();
          }, 10);
        }).then(function() {
          r.onload && r.onload();
        }).catch(function(t) {
          r.onerror && r.onerror(t);
        });
      },
      readyState: 4,
      upload: {
        onprogress: o.fn()
      },
      status: p,
      responseText: JSON.stringify({
        data: "mocked data"
      }),
      onload: o.fn(),
      onerror: o.fn()
    };
  });
}
var Jo = function(o, e, r) {
  n(function() {
    var i;
    if (e && o != null && (i = o.current) != null && i.parentElement) {
      var m, a = o == null || (m = o.current) == null ? void 0 : m.parentElement;
      r && (a.style.width = r);
    }
  }, [e, r, o]);
  var t = e && r ? "100%" : r;
  return [t];
};
export {
  nm as A,
  qo as Accordion,
  Ko as AccordionItem,
  Yo as AccordionPanel,
  $o as AspectRatio,
  rt as AvatarNew,
  tt as Badge,
  pt as BlogVideo,
  mt as Breadcrumb,
  nt as BulkActionBar,
  xt as Button,
  lt as ButtonGroup,
  Vt as CTAButton,
  fm as Caption,
  ct as Card,
  Tt as CardIllustration,
  Ct as CardIllustrationSection,
  Ke as Carousel,
  gt as Checkbox,
  yt as CheckboxList,
  bt as CheckboxStateValues,
  Gt as Chip,
  Ht as ChipGroup,
  Ye as CloseButton,
  Et as CreditCardInput,
  Nt as CurrencyInput,
  _t as DataList,
  Jt as DataTable,
  Xt as DatePicker,
  Ue as DecrementStepper,
  Kt as Disclosures,
  xm as Display1,
  sm as Display2,
  lm as Display3,
  um as DisplayTypoGraphy,
  Yt as Divider,
  Zt as DividerLayout,
  $t as DividerThickness,
  re as Drawer,
  oe as DrawerContent,
  te as DrawerFooter,
  ee as DrawerHeader,
  kt as DropdownMenu,
  Mt as DropdownMenuBase,
  Fp as Ellipses,
  Gp as EllipsesContainer,
  ie as FeatureText,
  ae as FileProgress,
  ne as FileUpload,
  fe as FileUploadProvider,
  ue as Filter,
  ce as FilterGroup,
  de as FiltersContainer,
  ye as FocusTrap,
  be as FocusTrapNavigationType,
  Me as GlobalAttributeBar,
  he as Grid,
  cm as H1,
  dm as H2,
  Tm as H3,
  Sm as H4,
  Cm as H5,
  Pm as H6,
  gm as HeadingTypoGraphy,
  $e as HelperText,
  Ie as Hero,
  Ae as HeroContentAlignment,
  ve as Icon,
  we as IconButton,
  Fe as IconColor,
  Ge as Icons,
  Re as Image,
  Je as InLineAlert,
  Xe as InLineText,
  Ne as IncrementSelector,
  Oe as IncrementStepper,
  je as InputState,
  ip as JumpLink,
  op as Label,
  ap as LandingHero,
  fp as LandingPageVideo,
  ym as Li,
  sp as Link,
  up as List,
  cp as ListIcon,
  dp as ListItem,
  Lt as MapCard,
  ht as MapCardGroup,
  Sp as MapMarker,
  Pp as MarkerVariants,
  yp as MarketingComparisonTable,
  bp as MarketingComparisonTableColumnButton,
  Mp as MarketingDataList,
  hp as MarketingList,
  Ip as MediaDisclosureButton,
  Bp as MegaMenu,
  Rp as ModalBody,
  Vp as ModalFooter,
  Up as ModalHeader,
  wp as ModalVideo,
  Np as ModalWindow,
  Li as MultiSelectInput,
  _e as NumberInputField,
  bm as Ol,
  km as P,
  _p as PageHeader,
  Jp as Pagination,
  Xp as PhoneInput,
  Kp as PhotoGallery,
  $p as PhotoGalleryLightbox,
  Yp as PhotoGalleryThumbnail,
  ri as PopupPlacement,
  oi as PopupTip,
  pi as PopupTipLinks,
  mi as ProgressBar,
  ni as ProgressStepState,
  fi as ProgressTracker,
  xi as ProgressTrackerOrientation,
  si as ProgressTrackerType,
  ui as ProgressTrackerVertical,
  Dt as Radio,
  It as RadioList,
  di as RaisedSurface,
  Si as ReadOnlySection,
  Pi as Search,
  yi as SearchInputLocation,
  ep as SecondaryNav,
  ki as SegmentControl,
  Ai as SelectionCard,
  Bi as SelectionTileCompactGroup,
  Fi as ShareLinks,
  Hi as ShowMoreLess,
  Ei as SidePanel,
  Di as SingleSelectInput,
  Vi as Skeleton,
  Ni as Slider,
  _i as Slot,
  Ji as SnackbarProvider,
  qi as Spinner,
  Te as StyledChipGroupContainer,
  Se as StyledFilterContainer,
  Ce as StyledFilterGroup,
  Pe as StyledTableFilterGroup,
  Mm as SubTitle,
  Qi as Switch,
  im as Tab,
  mm as TabList,
  rm as TabPanel,
  om as TabPanels,
  Zi as TableContext,
  $i as TableProvider,
  em as Tabs,
  At as Tag,
  Bt as TagsGroup,
  Lm as Text,
  Bm as TextArea,
  Fm as TextDisclosure,
  vt as TextInput,
  Hm as TimePickerInput,
  hm as Title,
  Em as Tooltip,
  Vm as TopBanner,
  Dm as Typography,
  xe as UPLOAD_STATUS,
  Im as Ul,
  Jm as VideoPlayer,
  zo as createMockXHR,
  _m as debounce,
  ti as getPosition,
  Jo as useAEMEditorComponentSize,
  Nm as useAccessibilityProps,
  se as useFileUploadContext,
  Wi as useSnackbars
};
